import { useEffect, useState } from "react";
import { useVendorsStore } from "../../../store/vendors.store";
import { useAuthStore } from "../../../store/auth.store";
import { useVendorProductSets } from "../../../hook/partner/vendorProductSets.partner.hook";
import number_format from "../../../utils/number_format";
import { PartnerApi } from "../../../api/partner.api";
import ProductConfigurationModal from "../../../components/modals/product/ProductConfigurationModal";
import OpportunityItemsModal from "../../../components/modals/opportunity/OpportunityItemsModal";
import { useTranslation } from "../../../hooks/useTranslation";

function VendorDetailProductSets(props) {
  const { t } = useTranslation();
  const vendor = props.vendor;

  const [directoryId, setDirectoryId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [cart, setCart] = useState([]);

  const [showOpportunityItemsModal, setShowOpportunityItemsModal] =
    useState(false);
  const [showProductConfigurationModal, setShowProductConfigurationModal] =
    useState(false);

  const vendorProductSetsMutation = useVendorProductSets();

  const token = useAuthStore((state) => state.token);
  const productSets = useVendorsStore((state) => state.productSets);

  useEffect(() => {
    if (token && vendor) {
      vendorProductSetsMutation.mutate({
        token,
        id: vendor.vendor_id,
        directory_id: directoryId,
      });
    }
  }, [token, vendor, directoryId]);

  if (vendorProductSetsMutation.isLoading) {
    return <p>{t("common.loading")}</p>;
  }

  if (
    productSets?.products?.length === 0 &&
    productSets?.subdirectories?.length === 0
  ) {
    return <>{t("vendors.noProduct")}</>;
  }

  return (
    <>
      {productSets?.name ? (
        <>
          {/*
                    <h1 className={"mt-16 mb-4"}>Samoobsluha</h1>
                    */}
          <div>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 mb-5">
              <li className="breadcrumb-item text-gray-700 fw-bold lh-1">
                <a href="javascript:;" onClick={() => setDirectoryId(0)}>
                  <i className="ki-duotone ki-home text-gray-700 fs-6" />
                </a>
              </li>
              {productSets?.directory_id > 0 &&
                productSets.bread_crumbs?.map((breadcrumb) => (
                  <>
                    <li className="breadcrumb-item">
                      <i className="ki-duotone ki-right fs-7 text-gray-700 mx-n1" />
                    </li>
                    <li className="breadcrumb-item text-gray-700 fw-bold lh-1">
                      {breadcrumb.dir_id === directoryId ? (
                        breadcrumb.name
                      ) : (
                        <a
                          href="javascript:;"
                          onClick={() => setDirectoryId(breadcrumb.dir_id)}
                        >
                          {breadcrumb.name}
                        </a>
                      )}
                    </li>
                  </>
                ))}
            </ul>
          </div>
          <h2 className="mb-4">{productSets.name}</h2>
          <div dangerouslySetInnerHTML={{ __html: productSets.description }} />
          <div className="row">
            {productSets?.subdirectories?.length > 0 &&
              productSets.subdirectories.map((directory, directory_key) => (
                <div className="col-12 col-md-4 mb-5" key={directory_key}>
                  <span
                    onClick={() => setDirectoryId(directory.direcotry_id)}
                    className="cursor-pointer card h-100"
                  >
                    <div className="card-body">
                      {directory.imagesAvailable === true && (
                        <img
                          className="mw-100 mb-4"
                          style={{
                            aspectRatio: "1 / 1",
                            objectFit: "contain",
                          }}
                          src={
                            PartnerApi.url +
                            "/vendor/" +
                            vendor.vendor_id +
                            "/productSets/" +
                            directory.direcotry_id +
                            "/cover.jpg"
                          }
                        />
                      )}

                      <h2 className="mb-0">{directory.name}</h2>
                    </div>
                  </span>
                </div>
              ))}

            <OpportunityItemsModal
              show={showOpportunityItemsModal}
              handleClose={() => setShowOpportunityItemsModal(false)}
              items={cart}
            />
            {productSets?.products?.length > 0 &&
              productSets.products.map((products, products_key) => (
                <div className="col-12 col-md-4 mb-5" key={products_key}>
                  <ProductConfigurationModal
                    show={showProductConfigurationModal === products.product.product_id}
                    handleClose={() => setShowProductConfigurationModal(false)}
                    product={products.product}
                    onSelect={(cart) => {
                      setShowProductConfigurationModal(false);
                      setShowOpportunityItemsModal(true);
                      setCart(cart);
                    }}
                  />

                  <span
                    onClick={() => setProductId(products.product_id)}
                    className="cursor-pointer card h-100"
                  >
                    <div className="card-body">
                      <img
                        className="mw-100 mb-4"
                        style={{
                          aspectRatio: "1 / 1",
                          objectFit: "contain",
                          border: "solid var(--bs-border-color) 1px",
                          borderRadius: "10px",
                        }}
                        src={
                          PartnerApi.url +
                          "/product/" +
                          products.product.product_id +
                          "/image.jpg"
                        }
                        alt={products.product_type + " " + products.name}
                      />

                      <h2 className="text-center">
                        {products.name
                          ? products.name
                          : products.product.product_type +
                            " " +
                            products.product.name}
                      </h2>
                      <div className="text-center">
                        <span className="badge badge-info mb-4">
                          {products.product.sku}
                        </span>
                      </div>
                      <h3 className="text-center">
                        {t("vendors.from")}{" "}
                        {number_format(
                          products.product.eu_price *
                            ((100 - products.product.discount) / 100),
                          2,
                          ",",
                          "."
                        )}{" "}
                        {products.product.currency}
                      </h3>
                      <div className="text-muted text-center">
                        {number_format(products.product.eu_price, 2, ",", ".")}{" "}
                        (-{products.product.discount}%)
                      </div>
                    </div>
                    <div className="card-footer">
                      <button
                        onClick={() =>
                          setShowProductConfigurationModal(products.product.product_id)
                        }
                        className="btn btn-primary w-100"
                      >
                        {t("vendors.configure")}
                      </button>
                    </div>
                  </span>
                </div>
              ))}
          </div>
        </>
      ) : (
        <p>{t("common.notFound")}</p>
      )}
    </>
  );
}

export default VendorDetailProductSets;
